<template>
  <section
    id="brand-value"
    class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-gradient-to-br from-[#0b105d] to-[#0c1260]"
  >
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
      <div class="text-center mb-10 sm:mb-12 md:mb-16">
        <h2
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#f4f4f4] mb-4"
          data-aos="fade-up"
        >
          {{ $t('brandValue.title') }}
        </h2>
        <div
          class="w-16 sm:w-20 md:w-24 h-1 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mx-auto"
          data-aos="fade-up"
          data-aos-delay="100"
        ></div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12">
        <div class="relative group" data-aos="zoom-in-right">
          <div
            class="absolute -inset-1 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] rounded-2xl sm:rounded-3xl blur-xl opacity-40 group-hover:opacity-60 transition-opacity duration-500"
          ></div>
          <div
            class="relative bg-[#0f172a]/80 backdrop-blur-xl rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 border border-[#ffb47c]/30 shadow-2xl h-full"
          >
            <h3
              class="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mb-6 sm:mb-8"
            >
              {{ $t('brandValue.Growth.title') }}
            </h3>
            <ul class="space-y-4 sm:space-y-6">
              <li class="flex items-start group/item">
                <div class="mr-3 sm:mr-4 mt-1 flex-shrink-0">
                  <div
                    class="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-[#fe6d0d] to-[#ffb47c] rounded-lg sm:rounded-xl flex items-center justify-center group-hover/item:scale-110 transition-transform"
                  >
                    <ZapIcon class="h-4 w-4 sm:h-5 sm:w-5 text-white" />
                  </div>
                </div>
                <span class="text-[#f4f4f4]/90 leading-relaxed text-sm sm:text-base">{{
                  $t('brandValue.Growth.description')
                }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="relative group" data-aos="zoom-in-left" data-aos-delay="100">
          <div
            class="absolute -inset-1 bg-gradient-to-r from-[#ffb47c] to-[#0b105d] rounded-2xl sm:rounded-3xl blur-xl opacity-40 group-hover:opacity-60 transition-opacity duration-500"
          ></div>
          <div
            class="relative bg-[#0f172a]/80 backdrop-blur-xl rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 border border-[#ffb47c]/30 shadow-2xl h-full flex flex-col"
          >
            <h3
              class="text-xl sm:text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#ffb47c] to-[#fe6d0d] mb-6 sm:mb-8"
            >
              {{ $t('brandValue.Adoptation.title') }}
            </h3>
            <ul class="space-y-4 sm:space-y-6 h-full justify-around flex flex-col">
              <li class="flex items-start group/item">
                <div class="mr-3 sm:mr-4 mt-1 flex-shrink-0">
                  <div
                    class="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-[#ffb47c] to-[#fe6d0d] rounded-lg sm:rounded-xl flex items-center justify-center group-hover/item:scale-110 transition-transform"
                  >
                    <ZapIcon class="h-4 w-4 sm:h-5 sm:w-5 text-white" />
                  </div>
                </div>
                <span class="text-[#f4f4f4]/90 leading-relaxed text-sm sm:text-base">{{
                  $t('brandValue.Adoptation.description')
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {
  ZapIcon
} from 'lucide-vue-next'
</script>
